import {Component, EventEmitter, Output} from '@angular/core';
import {HttpClientService} from "../../../core/services/http-client.service";
import {CartService} from "../../../core/services/cart.service";

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})

export class PaymentComponent {
  emiOptions: any = [];

  constructor(private http: HttpClientService, private cartService: CartService) {}

  @Output() selectedOption = new EventEmitter<any>();
  @Output() emiPlan = new EventEmitter<any>();

  paymentOptions : any =  {
    POD: { title: "Pay On Delivery", code: "COD~3000", cod:false },
    RZ: { title: "Wallet/ Cards /Netbanking /UPI", code: "RZ~0000", cod:false },
    CCAVE: {title : "Other online Payments", code:"CCAVE~0000", cod:false},
    EMIOD: { title: "EMI On Delivery", code: "EMIOD~3000", cod:false },
  };

  paymentKeys = Object.keys(this.paymentOptions);
  selectOption: any;
  makeOrderLoader: boolean = true;
  selectedRowIndex: number = 0;
  issuerIndex: number = 0;

  makeOrder(){
    this.selectedOption.emit(this.selectOption);
  }

  selectPaymentMode(option) {
    this.selectOption = option;
    if(option=='EMIOD'){
      this.makeOrderLoader = true;
      this.showEMIPlans();
    } else {
      this.makeOrderLoader = false;
    }
  }

  showEMIPlans() {
    let productDetails = [];
    this.cartService.getCartItems().forEach((product) => {
      productDetails.push({product_code:product.itemId, product_amount:product.sellingPrice*100});
    });
    const params = {
      provider: "pinelabs",
      amountInPaisa: this.cartService.getTotalPrice()*100,
      productDetails: JSON.stringify(productDetails)
    }
    this.http.post(`/payments/get-emi-options`,params).subscribe(emi => {
      if (emi.statusCode == 200) this.emiOptions = emi.response.issuers;
    })
  }

  selectEMIOption(option) {
    this.emiPlan.emit({...this.emiOptions[this.issuerIndex], selectedPlan: option});
  }

  placeEMIOrder(option) {
    this.emiPlan.emit({...this.emiOptions[this.issuerIndex], selectedPlan: option});
  }
}
